import { Permission } from '@bookora/shared';

import type { TourDef } from './types';

/**
 * «خدمات و تعرفه‌ها» (`/procedures`). «افزودن خدمت» switches to the catalogue
 * tab and focuses its search: services are ticked there, with the clinic's
 * price (a blank price takes the catalogue default). «خدمت خارج از فهرست خدمات بوکورا»
 * opens the custom-service drawer. The tariff card carries the photo-import
 * entry for a paper price list (`import.entry`, rendered only when the
 * feature, the kind and the caller's permissions allow it).
 */
export const PROCEDURES_TOUR: TourDef = {
  key: 'procedures',
  version: 1,
  surface: 'page',
  title: 'خدمات و تعرفه‌ها',
  hubDescription: 'خدماتی که ارائه می‌دید، با قیمت و مدت؛ از فهرست خدمات بوکورا یا اختصاصی.',
  offer: {
    body: 'در چند مرحله نشونتون می‌دیم چطور خدمات و قیمت‌ها رو به تعرفهٔ کلینیک اضافه کنید.',
  },
  route: { path: '/procedures', match: (pathname) => pathname === '/procedures' },
  requires: { all: [Permission.PROCEDURE_VIEW] },
  finish: {
    label: 'افزودن خدمت',
    to: '/procedures?tab=catalog',
    requires: { all: [Permission.PROCEDURE_MANAGE] },
  },
  autoOffer: true,
  maxSteps: 4,
  minSteps: 2,
  steps: [
    {
      id: 'tariff',
      anchor: 'procedures.tab-tariff',
      placement: 'bottom',
      title: 'تعرفهٔ کلینیک',
      body: 'خدماتی که ارائه می‌دید، با قیمت و مدت. همین فهرست در ثبت نوبت و ثبت جلسه درمان دیده می‌شه.',
    },
    {
      id: 'add',
      anchor: 'procedures.add',
      placement: 'bottom-end',
      requires: { all: [Permission.PROCEDURE_MANAGE] },
      title: 'افزودن خدمت',
      body: 'خدمات رو از فهرست آمادهٔ بوکورا تیک بزنید و قیمت خودتون رو بنویسید. اگر قیمتی ننویسید، قیمت پیش‌فرض فهرست خدمات بوکورا ثبت می‌شه.',
    },
    {
      id: 'custom',
      anchor: 'procedures.custom',
      placement: 'bottom-end',
      requires: { all: [Permission.PROCEDURE_MANAGE] },
      title: 'تعریف خدمت اختصاصی',
      body: 'اگر خدمتی رو در فهرست خدمات بوکورا پیدا نکردید، با نام خودتون بسازیدش.',
    },
    {
      id: 'import-photo',
      anchor: 'import.entry',
      placement: 'bottom-end',
      title: 'فهرست قیمت روی کاغذ',
      body: 'اگر لیست قیمت رو روی کاغذ دارید، از اون عکس بگیرید تا خدمات و قیمت‌ها خوانده بشن. تا بازبینی نکنید، چیزی ثبت نمی‌شه.',
    },
  ],
};
